import React from "react";

import "./button.styles.scss";

interface ButtonProps {
  children?: any;
  onClick?: any;
  className?: string;
}

const Button = ({ children, onClick, className }: ButtonProps, props: any) => (
  <button
    className={"_btn" + (className ? " " + className : "")}
    onClick={onClick}
    type="button"
    {...props}
  >
    {children}
  </button>
);

interface LinkProps {
  children?: any;
  href?: any;
  className?: string;
}

export const Link = ({ children, href, className }: LinkProps, props: any) => (
  <a href={href} className={`_btn ${className}`} {...props}>
    {children}
  </a>
);

export default Button;
